export const LinkV2Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width ?? 22}
      height={props.height ?? 22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={props["aria-label"] ? undefined : true}
    >
      <path
        d="M15.584 15.582L15.584 12.832C15.584 12.3279 15.1715 11.9154 14.6673 11.9154C14.1632 11.9154 13.7507 12.3279 13.7507 12.832V15.582C13.7507 17.0945 12.5132 18.332 11.0007 18.332C9.48815 18.332 8.25065 17.0945 8.25065 15.582V12.832C8.25065 12.3279 7.83815 11.9154 7.33398 11.9154C6.82982 11.9154 6.41732 12.3279 6.41732 12.832L6.41732 15.582C6.41732 18.112 8.47065 20.1654 11.0007 20.1654C13.5307 20.1654 15.584 18.112 15.584 15.582ZM11.0007 7.33203C10.4965 7.33203 10.084 7.74453 10.084 8.2487V13.7487C10.084 14.2529 10.4965 14.6654 11.0007 14.6654C11.5048 14.6654 11.9173 14.2529 11.9173 13.7487V8.2487C11.9173 7.74453 11.5048 7.33203 11.0007 7.33203ZM8.25065 9.16536V6.41536C8.25065 4.90286 9.48815 3.66536 11.0007 3.66536C12.5132 3.66536 13.7507 4.90286 13.7507 6.41536V9.16536C13.7507 9.66953 14.1632 10.082 14.6673 10.082C15.1715 10.082 15.584 9.66953 15.584 9.16536V6.41536C15.584 3.88536 13.5307 1.83203 11.0007 1.83203C8.47065 1.83203 6.41732 3.88536 6.41732 6.41536V9.16536C6.41732 9.66953 6.82982 10.082 7.33398 10.082C7.83815 10.082 8.25065 9.66953 8.25065 9.16536Z"
        fill="currentColor"
      />
    </svg>
  );
};
